/**
 * Form validation utilities
 */

/**
 * Validate name field
 * @param {string} name - Name to validate
 * @returns {Object} - { valid: boolean, error: string }
 */
export function validateName(name) {
  if (!name || typeof name !== 'string') {
    return { valid: false, error: 'Name is required' };
  }

  const trimmed = name.trim();
  
  if (trimmed.length === 0) {
    return { valid: false, error: 'Name cannot be empty' };
  }

  if (trimmed.length < 2) {
    return { valid: false, error: 'Name must be at least 2 characters long' };
  }

  if (trimmed.length > 100) {
    return { valid: false, error: 'Name must be less than 100 characters' };
  }

  // Allow any Unicode letter, spaces, hyphens, and apostrophes (supports all scripts)
  const namePattern = /^[\p{L}\s'-]+$/u;
  if (!namePattern.test(trimmed)) {
    return { valid: false, error: 'Name cannot contain numbers or symbols' };
  }

  return { valid: true, error: '' };
}

/**
 * Validate email field
 * @param {string} email - Email to validate
 * @returns {Object} - { valid: boolean, error: string }
 */
export function validateEmail(email) {
  if (!email || typeof email !== 'string') {
    return { valid: false, error: 'Email is required' };
  }

  const trimmed = email.trim();
  
  if (trimmed.length === 0) {
    return { valid: false, error: 'Email cannot be empty' };
  }

  // RFC 5322 compliant email regex (simplified but covers most cases)
  const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  
  if (!emailPattern.test(trimmed)) {
    return { valid: false, error: 'Please enter a valid email address' };
  }

  if (trimmed.length > 254) {
    return { valid: false, error: 'Email address is too long' };
  }

  return { valid: true, error: '' };
}

